import * as actiontypes from './actionTypes'

export const updateShipmentActiveCounter = (label) => (
    {
        type: actiontypes.UPDATE_SHIPMENT_ACTIVE_COUNTER,
        label
    }
)